import { render, staticRenderFns } from "./vipParctice.vue?vue&type=template&id=7b1ebe2a&scoped=true"
import script from "./vipParctice.vue?vue&type=script&lang=js"
export * from "./vipParctice.vue?vue&type=script&lang=js"
import style0 from "./vipParctice.vue?vue&type=style&index=0&id=7b1ebe2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1ebe2a",
  null
  
)

export default component.exports